import { ScrollableArea } from "@nova/component-scrollable-area"
import classNames from "classnames"
import * as Icons from "@nova/component-icons"

export const CardCollection = ({
    cards,
    orientation = "horizontal",
}: {
    cards: React.ReactNode[]
    orientation?: "vertical" | "horizontal"
}) => {
    return (
        <div className="border border-white-200 rounded-2xl w-full overflow-hidden">
            <ScrollableArea horizontal={orientation === "horizontal"}>
                <div
                    className={classNames("flex items-center w-full", {
                        "flex-col": orientation === "vertical",
                    })}
                >
                    {cards.map((c, i) => (
                        <div
                            key={i}
                            className={classNames("flex-1 flex justify-center items-center", {
                                "border-x border-x-white-100 min-w-fit":
                                    orientation === "horizontal",
                                "border-y border-y-white-100 min-h-fit w-full":
                                    orientation === "vertical",
                            })}
                        >
                            {c}
                        </div>
                    ))}
                </div>
            </ScrollableArea>
        </div>
    )
}

export const StatCard = ({
    Icon,
    title,
    body,
}: {
    Icon: Icons.IconComponent
    title: string
    body: string
}) => {
    return (
        <div className="flex-1 flex flex-col p-6 gap-3 min-w-fit">
            <Icons.Icon Icon={Icon} className="text-white-200" />
            <div className="flex flex-col gap-1">
                <small className="text-gray-400 mono">{title}</small>
                <div className="text-white text-2xl telegraf">{body}</div>
            </div>
        </div>
    )
}
